module.exports = __webpack_public_path__ + "img/init-process.79198da5.svg";